import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class WebviewMessageBus {
  private _channel: WebviewChannel = this.initChannel();

  initChannel(): WebviewChannel {
    if ('ReactNativeWebView' in window) {
      const postMessage = function (type: string, data?: object) {
        (window as any).ReactNativeWebView.postMessage(
          JSON.stringify({ type, data }),
        );
      };
      return {
        getUniqueUserSession() {
          if ('JSInterface' in window) {
            return (
              window.JSInterface as WebviewChannel
            ).getUniqueUserSession?.();
          }
          return undefined;
        },
        closeWebView() {
          postMessage('closeWebView');
        },
        retrieveAccessToken() {
          postMessage('retrieveAccessToken');
        },
        setRxCartTotal(cartCount: string) {
          postMessage('setRxCartTotal', { cartCount });
        },
        callToAction(ext: string, provider: string) {
          postMessage('callToAction', { ext, provider });
        },
        callToActionWithParams(auth: string, provider: string, fedUrl: string) {
          postMessage('callToActionWithParams', { auth, provider, fedUrl });
        },
      };
    }

    return {};
  }

  closeWebView() {
    if (this._channel.closeWebView) {
      this._channel.closeWebView();
    }
  }

  federateTo(auth: string, client: string, fedUrl: string) {
    if (this._channel.callToActionWithParams) {
      this._channel.callToActionWithParams(auth, client, fedUrl);
    }
  }
  viewPdf(auth: string, message: string) {
    if (this._channel.callToActionWithParams) {
      this._channel.callToActionWithParams(auth, message, '');
    }
  }

  accredoFederation(ext: string, provider: string) {
    if (this._channel.callToAction) {
      this._channel.callToAction(ext, provider);
    }
  }

  updateCartCount(cartCount: string) {
    if (this._channel.setRxCartTotal) {
      this._channel.setRxCartTotal(cartCount);
    }
  }

  getMobileSession() {
    return this._channel.getUniqueUserSession?.();
  }

  getTokens() {
    this._channel.retrieveAccessToken?.();
  }

  hasRetrieveAccessTokenMethod() {
    return !!this._channel.retrieveAccessToken;
  }
}

export interface WebviewChannel {
  closeWebView?(): void;
  callToActionWithParams?(auth: string, provider: string, fedUrl: string): void;
  callToAction?(ext: string, provider: string): void;
  setRxCartTotal?(cartCount: string): void;
  getUniqueUserSession?(): string | undefined;
  retrieveAccessToken?(): void;
}
